
import { defineComponent } from 'vue';
import { mapGetters } from 'vuex';

export default defineComponent({
  name: 'Button',
  props: {
    type: {
      type: String,
      default: 'primary'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    ariaDescribedby: {
      type: String,
      default: ''
    }
  },
  computed: {
    ...mapGetters([
      'global'
    ])
  },
  methods: {
    handleClick(event: Event) {
      this.$emit('onClick');
      if (this.disabled) {
        event.preventDefault();
        event.stopPropagation();
      }
    },
    handleFocus() {
      this.$emit('onFocus');
    }
  }
});
